import React, { useEffect } from "react";
import { useState } from "react";
import photo from "../../Images/pp.png";
import { FaFacebookSquare, FaGithubSquare, FaLinkedin } from "react-icons/fa";
import { FaArrowRight, FaEnvelope, FaFileDownload } from "react-icons/fa";
import TextTransition, { presets } from "react-text-transition";

const TEXTS = [
    "Full-Stack Developer",
    "Focused on Backend Engineering",
];

const Banner = () => {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        const intervalId = setInterval(
            () => setIndex((index) => index + 1),
            3000 // every 3 seconds
        );
        return () => clearTimeout(intervalId);
    }, []);

    return (
        <div className="hero my-10 overflow-x-hidden">
            <div className="hero-content flex-col md:flex-row">
                <div className="md:w-3/5">
                    <h2 className="text-orange-400 text-2xl md:text-4xl">
                        Hello there! I'm
                    </h2>
                    <h1
                        className="font-semibold text-yellow-50 text-4xl md:text-6xl mt-2 mb-4"
                        data-aos="zoom-in"
                        data-aos-duration="1000"
                    >
                        Gourob Saha Surjo
                    </h1>
                    <h2 className="text-orange-400 text-xl sm:text-2xl md:text-3xl text-left leading-tight sm:uppercase">
                        <span className="block max-w-[280px] sm:max-w-full break-words">
                            <TextTransition springConfig={presets.wobbly}>
                                {TEXTS[index % TEXTS.length]}
                            </TextTransition>
                        </span>
                    </h2>
                    <p className="text-yellow-100 opacity-90 text-base md:text-lg mt-5 max-w-2xl leading-relaxed">
                        I build end-to-end web products with a strong focus on
                        secure APIs, scalable backend architecture, and reliable
                        deployments using Node.js, NestJS, Next.js, MySQL,
                        PostgreSQL, and MongoDB.
                    </p>
                    <div className="mt-7 flex flex-wrap gap-3">
                        <a
                            href="#projects"
                            className="btn-brand-primary"
                        >
                            View Projects <FaArrowRight className="ml-2" />
                        </a>
                        <a
                            href="#contact"
                            className="btn-brand-secondary"
                        >
                            Contact Me <FaEnvelope className="ml-2" />
                        </a>
                        <a
                            href="/Resume.pdf"
                            download="Gourob_Resume.pdf"
                            className="btn-brand-secondary"
                        >
                            Download Resume <FaFileDownload className="ml-2" />
                        </a>
                    </div>
                    <div className="mt-3 flex flex-wrap gap-4 text-sm text-yellow-100">
                        <a
                            href="mailto:gourobsaha008@gmail.com"
                            className="hover:text-orange-400 transition"
                        >
                            Email: gourobsaha008@gmail.com
                        </a>
                        <a
                            href="tel:+8801733772851"
                            className="hover:text-orange-400 transition"
                        >
                            Phone: +8801733772851
                        </a>
                    </div>
                    <div className="mt-6 flex flex-wrap gap-2 text-xs md:text-sm">
                        <span className="px-3 py-1 rounded-full bg-slate-800 text-yellow-50 border border-orange-500">
                            3+ Years Professional Experience
                        </span>
                        <span className="px-3 py-1 rounded-full bg-slate-800 text-yellow-50 border border-orange-500">
                            Enterprise Production Projects
                        </span>
                        <span className="px-3 py-1 rounded-full bg-slate-800 text-yellow-50 border border-orange-500">
                            CI/CD with Jenkins & Vercel
                        </span>
                        <span className="px-3 py-1 rounded-full bg-slate-800 text-yellow-50 border border-orange-500">
                            Next.js & PostgreSQL Projects
                        </span>
                    </div>
                    <div className="mt-10 flex flex-row gap-6">
                        <a
                            href="https://github.com/GourobSaha"
                            target="_blank"
                            className="transition font-semibold ease-in-out delay-150 text-3xl hover:-translate-y-1 text-yellow-50 hover:scale-110 hover:text-orange-400 duration-300"
                            rel="noopener noreferrer"
                        >
                            <FaGithubSquare />
                        </a>
                        <a
                            href="https://www.linkedin.com/in/gourob-saha-surjo-632751200/"
                            target="_blank"
                            className="transition font-semibold ease-in-out delay-150 text-3xl hover:-translate-y-1 text-yellow-50 hover:scale-110 hover:text-orange-400 duration-300"
                            rel="noopener noreferrer"
                        >
                            <FaLinkedin />
                        </a>
                        <a
                            href="https://www.facebook.com/surjo.saha.547/"
                            target="_blank"
                            className="transition font-semibold ease-in-out delay-150 text-3xl hover:-translate-y-1 text-yellow-50 hover:scale-110 hover:text-orange-400 duration-300"
                            rel="noopener noreferrer"
                        >
                            <FaFacebookSquare />
                        </a>
                    </div>
                </div>
                <div
                    className="card flex-shrink-0 md:w-2/5 w-full"
                    data-aos="zoom-in"
                    data-aos-duration="2000"
                >
                    <div className="w-full max-w-md mx-auto">
                        <div className="bg-slate-900 border border-orange-500/30 rounded-2xl p-3">
                            <img
                                src={photo}
                                alt="Portrait of Gourob Saha Surjo"
                                className="w-full rounded-xl object-cover border border-orange-400/35"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Banner;
